import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { GROUP_COMMUNITIES_STATUS, GROUP_COMMUNITIES_STATUS_LABEL } from 'constants/groups';

import { useGroupsContext } from '../GroupsContext';

const GroupsFiltersCommunitiesCount = () => {
  const { filters, setFilters } = useGroupsContext();

  const handleSelect = (selection: any[]) => {
    const values = selection.map((item: any) => item.value);
    setFilters({ ...filters, page: 1, has_communities: values });
  };

  const options = [
    {
      label: GROUP_COMMUNITIES_STATUS_LABEL[GROUP_COMMUNITIES_STATUS.WITH_COMMUNITIES],
      value: GROUP_COMMUNITIES_STATUS.WITH_COMMUNITIES,
    },
    {
      label: GROUP_COMMUNITIES_STATUS_LABEL[GROUP_COMMUNITIES_STATUS.WITHOUT_COMMUNITIES],
      value: GROUP_COMMUNITIES_STATUS.WITHOUT_COMMUNITIES,
    },
  ];

  return (
    <SelectAdvancedFilter
      className={classNames({ active: Boolean(filters.has_communities?.length) })}
      placeholder={'Communities'}
      options={options}
      defaultValue={filters?.has_communities ?? []}
      onSelect={handleSelect}
    />
  );
};

export default GroupsFiltersCommunitiesCount;
